import { app } from './app'

app.$mount('#app')



// WEBPACK FOOTER //
// ./client/index.js